import {
  OperationsDataContent,
  OperationsTabsContent,
} from '@facephi/inphinite-operations';
import { Dropdown, FlexContainer, Modal } from '@facephi/ui-react';
import styled from 'styled-components/macro';

export const DropdownAntiFraud = styled(Dropdown)`
  width: 7.4rem;
`;

export const HeaderBanned = styled(FlexContainer)`
  margin-bottom: 6rem;
`;

export const BannedTabsContent = styled(OperationsTabsContent)``;

export const BannedDataContent = styled(OperationsDataContent)``;

export const HeaderRulesStyles = styled(FlexContainer)`
  margin: 2rem 1.6rem;
`;

export const RulesTabsWrapper = styled(FlexContainer)`
  height: 100%;
`;

export const ModalIPStyles = styled(Modal)`
  width: 52rem;
`;

export const TableFaceImg = styled.img`
  width: 5rem;
  aspect-ratio: 1;
  object-fit: cover;
`;

export const TablePopImg = styled.img`
  width: 5rem;
  object-fit: cover;
`;
